import { CircularProgress, Skeleton } from "@mui/material";
import CenterBox from "../CenterBox";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../Firebase/SDK/firebaseAuth";
import { useUserContext } from "../../User/Auth/UserContext";
export default function AuthCheckLoadingInside(props: {
  // loadingNode?: React.ReactNode;
  fallback: React.ReactNode;
  children: React.ReactNode;
}) {
  //  這個fallback會爛掉, 還沒檢查完就切走
  const [user, loading, error] = useAuthState(auth);
  const userCtx = useUserContext();
  if (loading) {
    return <LoadingSection></LoadingSection>;
  }
  if (error) {
    return <div>{error.message}</div>;
  }
  return (
    // <React.Suspense fallback={props.fallback}>
    <div>
      {
        user && userCtx.IsAccountValid ? props.children : props.fallback
        // requiredClaims={{ policy_agreed: true }}
      }
      {/* </React.Suspense> */}
    </div>
  );
}
const LoadingSection = () => {
  return (
    <CenterBox>
      {/* <CircularProgress></CircularProgress> */}
      <Skeleton variant="rectangular" />
    </CenterBox>
  );
};
